import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { PaymentMethod } from "../models/payment_method.model";
import { GraphQLService } from "./graphql.service";
import { HttpClient } from "@angular/common/http";
import { MatSnackBar } from "@angular/material/snack-bar";

@Injectable()
export class PaymentMethodService extends GraphQLService<PaymentMethod> {

  constructor(
    http: HttpClient,
    snackBar: MatSnackBar
  ) {
    super(http, snackBar)
  }

  getPaymentMethods(amount: number, currency: string): Observable<PaymentMethod[]> {
    return this.findAll(`{ paymentMethods(amount: ${ amount }, currency: "${ currency }") { name provider type brands } }`)
  }

}
